import { ShoppingBag, Plus } from "lucide-react";
import LinkCard from "./LinkCard";

export default function BuyTabContent({ links, isAuthor, onAddAffiliate, postId }) {
  if (links.length === 0) {
    return (
      <div className="text-center py-10">
        <div
          className="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4"
          style={{
            background: "rgba(99,102,241,0.08)",
            border: "1px solid rgba(99,102,241,0.15)",
          }}
        >
          <ShoppingBag className="w-5 h-5" style={{ color: "#818CF8" }} />
        </div>
        {isAuthor ? (
          <>
            <p className="text-white/60 text-sm font-medium mb-1">Add your first affiliate link</p>
            <p className="text-white/25 text-xs leading-relaxed mb-4">
              Earn commission from products you feature in your posts
            </p>
            <button
              onClick={onAddAffiliate}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full
                text-xs font-semibold transition-all duration-200 hover:scale-105 active:scale-95"
              style={{
                background: "linear-gradient(135deg, rgba(99,102,241,0.2) 0%, rgba(139,92,246,0.2) 100%)",
                border: "1px solid rgba(99,102,241,0.3)",
                color: "#A5B4FC",
              }}
            >
              <Plus className="w-3.5 h-3.5" />
              Add Affiliate Link
            </button>
          </>
        ) : (
          <>
            <p className="text-white/40 text-sm font-medium">No products linked yet</p>
            <p className="text-white/20 text-xs mt-1">The creator hasn't added any product links</p>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      {links.map((link, i) => (
        <LinkCard key={link.id || i} link={link} postId={postId} isOwner={false} />
      ))}
      {isAuthor && (
        <button
          onClick={onAddAffiliate}
          className="w-full py-2.5 mt-1 rounded-xl text-sm border border-dashed
            flex items-center justify-center gap-1.5 transition-colors"
          style={{
            color: "rgba(165,180,252,0.5)",
            borderColor: "rgba(99,102,241,0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#A5B4FC";
            e.currentTarget.style.borderColor = "rgba(99,102,241,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "rgba(165,180,252,0.5)";
            e.currentTarget.style.borderColor = "rgba(99,102,241,0.2)";
          }}
        >
          <Plus className="w-3.5 h-3.5" />
          Add Affiliate Link
        </button>
      )}
    </div>
  );
}
